<section class="bag" [class.is-empty]="cartService.items().length === 0" [class.bag--drawer]="variant === 'drawer'">
  <div class="bag-top">
    <a class="bag-top__back" href="#" aria-label="Go back" (click)="goBack($event)">
      <img src="assets/icons/bag-back.svg" alt="" width="28" height="28" />
    </a>
    <h1>Bag</h1>
  </div>

  @if (!authService.isAuthenticated()) {
    <article class="bag-card bag-offer">
      <p>Get Started &amp; Grab Best Offers!</p>
      <a class="bag-offer__btn" routerLink="/login" [queryParams]="authOfferParams()" (click)="onNavigate()">Login</a>
      <a class="bag-offer__btn" routerLink="/signup" [queryParams]="authOfferParams()" (click)="onNavigate()">Sign Up</a>
    </article>
  }

  @for (item of cartService.items(); track cartService.lineKey(item.catalogId, item.variantId)) {
    <article class="bag-card bag-product">
      <a class="bag-product__media" [routerLink]="['/products', item.catalogSlug]" (click)="onNavigate()">
        <app-media-image
          [src]="item.imageUrl || 'assets/images/bag-product.png'"
          [alt]="item.productName"
          fit="cover"
          size="sm"
          fallback="assets/images/bag-product.png"
        />
      </a>
      <div class="bag-product__info">
        <h2 class="bag-product__title">
          <a [routerLink]="['/products', item.catalogSlug]" (click)="onNavigate()">{{ item.productName }}</a>
        </h2>
        <div class="bag-product__rating">
          <img src="assets/icons/bag-stars.svg" alt="" width="109" height="23" />
          <span class="bag-product__count">({{ reviewCount(item.catalogId) }})</span>
        </div>
        <p class="bag-product__meta">
          {{ reviewCount(item.catalogId) }} Review{{ reviewCount(item.catalogId) === 1 ? '' : 's' }}
          @if (item.variantName) {
            | {{ item.variantName }}
          }
        </p>
        <div class="dropdown" [class.is-open]="openQtyKey() === cartService.lineKey(item.catalogId, item.variantId)">
          <button
            class="bag-product__qty dropdown__btn"
            type="button"
            [attr.aria-expanded]="openQtyKey() === cartService.lineKey(item.catalogId, item.variantId)"
            (click)="toggleQty($event, item)"
          >
            <span>Quantity: <span>{{ item.quantity }}</span></span>
            <img src="assets/icons/bag-qty-chevron.svg" alt="" width="24" height="24" />
          </button>
          <ul class="dropdown__menu bag-qty-menu">
            @for (qty of qtyOptions(item.quantity); track qty) {
              <li>
                <button type="button" (click)="setQuantity(item, qty)">{{ qty }}</button>
              </li>
            }
          </ul>
        </div>
      </div>
      <button
        class="bag-product__delete"
        type="button"
        aria-label="Remove item"
        (click)="removeItem(item)"
      >
        <img src="assets/icons/bag-delete.svg" alt="" width="36" height="36" />
      </button>
      <div class="bag-product__pay">
        <span>you pay</span>
        <span>${{ cartService.lineTotal(item).toFixed(2) }}</span>
      </div>
    </article>
  }

  <button
    class="bag-card bag-link bag-link--coupon bag-card--coupon"
    type="button"
    [class.is-open]="couponOpen()"
    [attr.aria-expanded]="couponOpen()"
    (click)="toggleCoupons()"
  >
    <img src="assets/icons/bag-coupon.svg" alt="" width="54" height="53" />
    <span class="bag-link__copy">
      <strong>Coupons</strong>
      <span>Apply now and save extra!</span>
    </span>
    <img class="bag-link__chevron" src="assets/icons/bag-chevron.svg" alt="" width="24" height="24" />
  </button>
  <div class="bag-coupon" [class.is-open]="couponOpen()">
    <div class="bag-coupon__row">
      <input
        type="text"
        name="bag-coupon-code"
        placeholder="Enter coupon code"
        [value]="cartService.pendingCouponCode()"
        [disabled]="isCouponLoading()"
        (input)="onCouponInput($any($event.target).value)"
        (keyup.enter)="applyCoupon()"
        aria-label="Coupon code"
      />
      <button type="button" class="bag-coupon__apply" [disabled]="isCouponLoading()" (click)="applyCoupon()">
        {{ isCouponLoading() ? 'Applying…' : 'Apply' }}
      </button>
    </div>
    @if (couponError()) {
      <p class="bag-coupon__message bag-coupon__message--error">{{ couponError() }}</p>
    }
    @if (cartService.appliedCoupon(); as coupon) {
      <p class="bag-coupon__message bag-coupon__message--success">
        Coupon applied: {{ coupon.code }} (−${{ coupon.discountAmount.toFixed(2) }})
        <button type="button" class="bag-coupon__remove" (click)="clearCoupon()">Remove</button>
      </p>
    }
  </div>

  <button
    class="bag-card bag-link bag-card--details"
    type="button"
    [class.is-open]="detailsOpen()"
    [attr.aria-expanded]="detailsOpen()"
    (click)="detailsOpen.update((open) => !open)"
  >
    <span class="bag-link__dollar">$</span>
    <span class="bag-link__copy">
      <strong>Price details</strong>
    </span>
    <img class="bag-link__chevron" src="assets/icons/bag-chevron.svg" alt="" width="24" height="24" />
  </button>
  <div class="bag-details" [class.is-open]="detailsOpen()">
    <p><span>Item total</span><span>${{ cartService.subtotal().toFixed(2) }}</span></p>
    @if (cartService.couponDiscount() > 0) {
      <p>
        <span>Coupon{{ cartService.appliedCoupon() ? ' (' + cartService.appliedCoupon()!.code + ')' : '' }}</span>
        <span>−${{ cartService.couponDiscount().toFixed(2) }}</span>
      </p>
    }
    <p><span>Grand Total</span><span>${{ cartService.grandTotal().toFixed(2) }}</span></p>
  </div>

  <p class="bag-empty">Your bag is empty.</p>

  <div class="bag-checkout">
    <div class="bag-checkout__total">
      <span class="bag-checkout__price">${{ cartService.grandTotal().toFixed(2) }}</span>
      <span class="bag-checkout__label">Grand Total</span>
    </div>
    <div class="bag-checkout__actions">
      @if (variant === 'drawer') {
        <button class="bag-checkout__btn bag-checkout__btn--secondary" type="button" (click)="viewBag()">
          view bag
        </button>
      }
      <button
        class="bag-checkout__btn"
        type="button"
        [disabled]="cartService.items().length === 0 || cartService.isNavigatingToCheckout()"
        (click)="proceed()"
      >
        {{ cartService.isNavigatingToCheckout() ? 'please wait' : 'proceed' }}
      </button>
    </div>
  </div>
</section>
